










































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ServiceRequestModel } from '../../types/request';
import { MedTransGoConstants } from '../../util/constants';
import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import DatePicker from '../../components/DatePicker.vue';
import { HealthcareProvider, OrgLocation, Patient } from '../../types/entity';
import { ObjectFactory } from '../../config/objectFactory';
import AddLocationModal from '../modal/AddLocationModal.vue';
import AddPatientModal from '../modal/AddPatientModal.vue';
import AddHealthcareProviderModal from '../modal/AddHealthCareProviderModal.vue';
import { MemberProfile } from '@/types/response';
import { ModelSelect } from 'vue-search-select';
import { DateUtils } from '@/util/dateUtils';
import { CommonUtils } from '@/util/commonUtils';
import VSelect from 'vue-select';
declare var google: any;
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
@Component({
    mixins: [validationMixin],
    props: {
        serviceRequest: Object,
    },
    components: {
        DatePicker,
        AddLocationModal,
        ModelSelect,
        AddHealthcareProviderModal,
        AddPatientModal,
        VSelect,
    },
    computed: {
        lastMinuteMessage() {
            const addressBilling = this as AddressBilling;
            const lastMinuteMessage = CommonUtils.translateMessageCode('MSG_LAST_MINUTE_REQUEST');
            if (!this.$props.serviceRequest.multipleAppointment && addressBilling.isLastMinuteRequest) {
                return lastMinuteMessage;
            }
        },
        lastMinuteMessageForMultiple() {
            const addressBilling = this as AddressBilling;
            const lastMinuteMessage = CommonUtils.translateMessageCode('MSG_LAST_MINUTE_REQUEST');
            if (this.$props.serviceRequest.multipleAppointment && addressBilling.isLastMinuteRequest) {
                return lastMinuteMessage;
            }
        },
    },
    data() {
        return {
            member: ObjectFactory.getCacheService().getMemberInfo(),
            pickupAddress: {
                address1: '',
                address2: '',
                state: '',
                city: '',
                county: '',
                landmark: '',
                zip: '',
                pickupInstruction: '',
            },
            dropoffAddress: {
                address1: '',
                address2: '',
                state: '',
                city: '',
                county: '',
                landmark: '',
                zip: '',
                dropOffInstruction: '',
            },
            options: [],
            providersOptions: [],
            preferredProviders: [],
            patientOptions: [],
            item: {
                value: '',
                text: '',
            },
        };
    },
    validations() {
        const validations = {
            serviceRequest: {
                facility: {
                    name: {
                        required,
                    },
                    email: {
                        required,
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(10),
                        regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                    },
                    address: {
                        fullAddress: {
                            required,
                        },
                        state: {
                            required,
                        },
                        city: {
                            required,
                        },
                        zip: {
                            required,
                        },
                    },
                },
                patient: {
                    fullName: {
                        required,
                        regex: (fullName: any) => /^[a-zA-Z ]+$/.test(fullName),
                    },
                    email: {
                        required,
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(10),
                        regex: (phone: any) => MedTransGoConstants.PHONE_REGX.test(phone),
                    },
                    address: {
                        fullAddress: {
                            required,
                        },
                        locality: {
                            required,
                        },
                        state: {
                            required,
                        },
                        city: {
                            required,
                        },
                        zip: {
                            required,
                        },
                    },
                },
                pickupAddress: {
                    fullAddress: {
                        required,
                    },
                    state: {
                        required,
                    },
                    city: {
                        required,
                    },
                    zip: {
                        required,
                    },
                },
                dropoffAddress: {
                    fullAddress: {
                        required,
                    },
                    state: {
                        required,
                    },
                    city: {
                        required,
                    },
                    zip: {
                        required,
                    },
                },
                billingLocationId: {
                    required,
                },
                transportation: {
                    attorneyName: {
                        required,
                        regex: (attorneyName: any) => /^[a-zA-Z ]+$/.test(attorneyName),
                    },
                    attorneyEmail: {
                        required,
                        email,
                    },
                    attorneyFirmName: {
                        required,
                    },
                    attorneyPhoneNo: {
                        required,
                    },
                },
                delivery: {
                    confirmationMode: {
                        required,
                    },
                },
                cmr: {
                    patientSecPhone: {
                        regex: (patientSecPhone: any) => MedTransGoConstants.PHONE_REGX.test(patientSecPhone),
                    },
                },
                appointments: {
                    required,
                    $each: {
                        date: {
                            required,
                        },
                        time: {
                            required,
                        },
                    },
                },
                preferredProviderRequired: {
                    required,
                },
                preferredProvider: {
                    required,
                },
            },
        };
        const serviceRequest = this.$props.serviceRequest;
        if (serviceRequest.service.type === 'Interpretation'
            && serviceRequest.interpretation.serviceType !== 'In-Person') {
            delete validations.serviceRequest.dropoffAddress;
            delete validations.serviceRequest.pickupAddress;
            delete validations.serviceRequest.patient.address;
            delete validations.serviceRequest.facility.address;
        }
        if (serviceRequest.service.type === 'Interpretation'
            && serviceRequest.interpretation.serviceType === 'In-Person') {
            delete validations.serviceRequest.dropoffAddress;
            delete validations.serviceRequest.pickupAddress;
            delete validations.serviceRequest.facility.email;
            delete validations.serviceRequest.facility.phone;
        }
        if (serviceRequest.service.type === 'Interpretation'
            && serviceRequest.interpretation.serviceType !== 'Video') {
            delete validations.serviceRequest.patient.email.required;
        }
        if (serviceRequest.service.type === 'Interpretation'
            && serviceRequest.interpretation.serviceType === 'Phone') {
            delete validations.serviceRequest.facility.email.required;
        }
        if (serviceRequest.service.type === 'Telemedicine') {
            delete validations.serviceRequest.dropoffAddress;
            delete validations.serviceRequest.pickupAddress;
            delete validations.serviceRequest.patient;
            delete validations.serviceRequest.facility;
        }
        if (serviceRequest.service.type === 'Delivery') {
            delete validations.serviceRequest.dropoffAddress;
            delete validations.serviceRequest.pickupAddress;
            delete validations.serviceRequest.facility;
        }
        if (serviceRequest.service.type !== 'Delivery') {
            delete validations.serviceRequest.delivery.confirmationMode;
        }
        if (serviceRequest.service.type === 'Delivery' && serviceRequest.delivery.isCmr) {
            delete validations.serviceRequest.delivery.confirmationMode;
        }
        if (serviceRequest.service.type === 'Transportation') {
            delete validations.serviceRequest.facility.email;
            delete validations.serviceRequest.facility.phone;
        }
        if (this.$data.member.memberType !== 'ORG_LIEN_CUSTOMER' || serviceRequest.service.type !== 'Transportation') {
            delete validations.serviceRequest.transportation.attorneyName;
            delete validations.serviceRequest.transportation.attorneyEmail;
            delete validations.serviceRequest.transportation.attorneyPhoneNo;
            delete validations.serviceRequest.transportation.attorneyFirmName;
        }
        if (serviceRequest.service.type === 'TransInterpreter'
            && serviceRequest.interpretation.serviceType === 'In-Person') {
            delete validations.serviceRequest.facility.email;
        }
        if (!this.$props.serviceRequest.delivery.isCmr) {
            delete validations.serviceRequest.cmr;
        }
        if (this.$props.serviceRequest.delivery && this.$props.serviceRequest.delivery.isCmr &&
            this.$props.serviceRequest.cmr.patientSecPhone === undefined) {
            delete validations.serviceRequest.cmr.patientSecPhone.regex;
        }
        if (CommonUtils.isEmpty(this.$data.preferredProviders)) {
            delete validations.serviceRequest.preferredProviderRequired;
            delete validations.serviceRequest.preferredProvider;
        } else if (serviceRequest.preferredProviderRequired !== null) {
            if (!serviceRequest.preferredProviderRequired) {
                delete validations.serviceRequest.preferredProvider;
            }
        }
        return validations;
    },
})
export default class AddressBilling extends Vue {

    private facilityGoogleAddress: any;
    private patientGoogleAddress: any;
    private pickupGoogleAddress: any;
    private dropoffGoogleAddress: any;
    private showAddHealthcareProviderForm = false;
    private showAddPatientForm = false;
    private isInvalidValidTime = false;

    private locations: OrgLocation[] = [];

    private memberProfile: MemberProfile = ObjectFactory.getCacheService().getMemberInfo();
    private showAddLocationForm = false;
    private isLastMinuteRequest = false;
    private healthcareProviders: HealthcareProvider[] = [];
    private patient: Patient[] = [];
    private questionCounter = 0;
    private maxDate = new Date();
    private TimeZones = TimeZones;


    public mounted() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.stops.isStop2Valid) {
            if (serviceRequest.service.selectedType === 'Telemedicine') {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_MEETING_DETAILS });
            } else if (serviceRequest.service.selectedType === 'Delivery') {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_PICKUP_DETAILS });
            } else {
                this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_VEHICLE_LANGUAGE });
            }
            return;
        }
        if (serviceRequest.service.selectedType !== 'Telemedicine') {
            this.patientGoogleAddress = new google.maps.places.Autocomplete(this.$refs.patientAddress,
                { types: ['geocode'] });

            if (serviceRequest.service.selectedType !== 'Delivery') {
                this.facilityGoogleAddress = new google.maps.places.Autocomplete(this.$refs.facilityAddress,
                    { types: ['geocode'] });
                this.facilityGoogleAddress.addListener('place_changed', () => {
                    this.$props.serviceRequest.facility.address =
                        MapUtils.parseGoogleAddress(this.facilityGoogleAddress);
                    this.copyDropoffAddresses();
                    this.copyPickupAddresses();
                });
            }
            this.patientGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.patient.address = MapUtils.parseGoogleAddress(this.patientGoogleAddress);
                if (serviceRequest.service.selectedType !== 'Delivery') {
                    this.copyPickupAddresses();
                    this.copyDropoffAddresses();
                }
            });
        }
        if (serviceRequest.service.type !== 'Interpretation') {
            this.pickupGoogleAddress = new google.maps.places.Autocomplete(this.$refs.pickupGoogleAddress,
                { types: ['geocode'] });
            this.pickupGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.pickupAddress = MapUtils.parseGoogleAddress(this.pickupGoogleAddress);
            });
            this.dropoffGoogleAddress = new google.maps.places.Autocomplete(this.$refs.dropoffGoogleAddress,
                { types: ['geocode'] });
            this.dropoffGoogleAddress.addListener('place_changed', () => {
                this.$props.serviceRequest.dropoffAddress = MapUtils.parseGoogleAddress(this.dropoffGoogleAddress);
            });
        }
        if (serviceRequest.service.type === 'Interpretation' && serviceRequest.interpretation &&
            serviceRequest.interpretation.isImmediateInterpretation) {
            serviceRequest.appointments[0].date = DateUtils.formatDate(new Date(), 'YYYY-MM-DD');
            serviceRequest.appointments[0].time = DateUtils.formatDate(new Date().getTime()
                + DateUtils.convertMinutesToMillis(5), 'HH:mm');
            this.questionCounter = 1;
        } else {
            this.questionCounter = 0;
        }
        this.getOrganizationLocations();
        this.getHealthcareProviders();
        this.getPatientList();
        this.maxDate.setFullYear(this.maxDate.getFullYear());
        if (serviceRequest.service.type === 'Transportation' || serviceRequest.service.type === 'Interpretation') {
            this.$data.preferredProviders = this.$store.state.preferredProviders;
            if (CommonUtils.isEmpty(this.$data.preferredProviders)) {
                serviceRequest.preferredProviderRequired = null as any;
                serviceRequest.preferredProvider = '' as any;
            }
        }
    }
    private copyPickupAddresses() {
        let pickupInstruction = '';
        if (this.$props.serviceRequest.pickupAddress.pickupInstruction) {
            pickupInstruction = this.$props.serviceRequest.pickupAddress.pickupInstruction;
        }
        if (this.$props.serviceRequest.pickupSameAsPatientAddress) {
            this.$props.serviceRequest.pickupAddress = this.$props.serviceRequest.patient.address;
        } else if (this.$props.serviceRequest.pickupSameAsBussinessAddress) {
            this.$props.serviceRequest.pickupAddress = this.$props.serviceRequest.facility.address;
        } else if (this.$props.serviceRequest.pickupAddress.fullAddress
            && this.$props.serviceRequest.patient.address.fullAddress
            && this.$props.serviceRequest.patient.address.fullAddress ===
            this.$props.serviceRequest.pickupAddress.fullAddress) {
            this.$props.serviceRequest.pickupAddress = {};
        } else if (this.$props.serviceRequest.pickupAddress.fullAddress
            && this.$props.serviceRequest.facility.address.fullAddress
            && this.$props.serviceRequest.facility.address.fullAddress ===
            this.$props.serviceRequest.pickupAddress.fullAddress) {
            this.$props.serviceRequest.pickupAddress = {};
        }
        this.$props.serviceRequest.pickupAddress.pickupInstruction = pickupInstruction;
    }
    private copyDropoffAddresses() {
        let dropOffInstruction = '';
        if (this.$props.serviceRequest.dropoffAddress.dropOffInstruction) {
            dropOffInstruction = this.$props.serviceRequest.dropoffAddress.dropOffInstruction;
        }
        if (this.$props.serviceRequest.dropoffSameAsBussinessAddress) {
            this.$props.serviceRequest.dropoffAddress = this.$props.serviceRequest.facility.address;
        } else if (this.$props.serviceRequest.dropoffSameAsPatientAddress) {
            this.$props.serviceRequest.dropoffAddress = this.$props.serviceRequest.patient.address;
        } else if (this.$props.serviceRequest.dropoffAddress.fullAddress
            && this.$props.serviceRequest.patient.address.fullAddress
            && this.$props.serviceRequest.patient.address.fullAddress ===
            this.$props.serviceRequest.dropoffAddress.fullAddress) {
            this.$props.serviceRequest.dropoffAddress = {};
        } else if (this.$props.serviceRequest.dropoffAddress.fullAddress
            && this.$props.serviceRequest.facility.address.fullAddress
            && this.$props.serviceRequest.facility.address.fullAddress ===
            this.$props.serviceRequest.dropoffAddress.fullAddress) {
            this.$props.serviceRequest.dropoffAddress = {};
        }
        this.$props.serviceRequest.dropoffAddress.dropOffInstruction = dropOffInstruction;
    }
    private async getOrganizationLocations() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (!serviceRequest.locations || serviceRequest.locations.length <= 0) {
            const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
            if (response.success && response.data) {
                serviceRequest.locations = response.data;
            }
        }
        if (serviceRequest.locations) {
            this.locations = serviceRequest.locations;
            serviceRequest.locations.forEach((location) => {
                const option = {
                    value: location.id,
                    text: location.locationName,
                };
                this.$data.options.push(option);
            });
        }
    }
    private checkIsLastMinute() {
        const currentTime = DateUtils.getCurrentUTCTimeInMillis();
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.service.type === 'Transportation' && serviceRequest.appointments) {
            for (const appointment of serviceRequest.appointments) {
                const dateTime = DateUtils.formatDate(appointment.date + ' ' +
                    appointment.time, 'YYYY-MM-DDTHH:mm:ss.sssZ', appointment.timezone);
                const appointmentTimestamp = Date.parse(new Date(dateTime).toUTCString());
                const difference = DateUtils.convertMillisToMinutes(appointmentTimestamp -
                    currentTime);
                if (difference < 60) {
                    const scope = ObjectFactory.getCacheService().getSessionInfo().scopes;
                    if ((scope.includes('admin') || !serviceRequest.roundTrip) && difference > 0) {
                        this.isInvalidValidTime = false;
                    } else {
                        this.isInvalidValidTime = true;
                    }
                    break;
                } else {
                    this.isInvalidValidTime = false;
                }
            }
            for (const appointment of serviceRequest.appointments) {
                const appointmentTimestamp = DateUtils.convertToUTCInMillis(appointment.date + ' ' +
                    appointment.time, appointment.timezone);
                const difference = DateUtils.convertMillisToMinutes(appointmentTimestamp -
                    currentTime);
                if (difference < 240) {
                    this.isLastMinuteRequest = true;
                    break;
                } else {
                    this.isLastMinuteRequest = false;
                }
            }
        }
    }
    private validateTime(index?: number) {
        const objIndex = index ? index : 0;
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments) {
            let time = new Array();
            time = serviceRequest.appointments[objIndex].time.split(':');
            const hours = parseInt(time[0], 10);
            const minutes = parseInt(time[1], 10);
            if (isNaN(hours) || 0 > hours || hours >= 24 || isNaN(minutes) || 0 > minutes || minutes >= 60) {
                serviceRequest.appointments[objIndex].time = '';
            }
        }
    }
    private validateDate() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.patient.birthdate) {
            const birthdate = new Date(serviceRequest.patient.birthdate);
            const today = new Date();
            if (birthdate > today) {
                serviceRequest.patient.birthdate = '';
            }
        }
    }
    private copyHealthCareAddress(fullname: string) {
        if (this.healthcareProviders) {
            this.healthcareProviders.forEach((healthcareProvider) => {
                if (healthcareProvider.fullname === fullname) {
                    if (healthcareProvider.address) {
                        this.$props.serviceRequest.facility.address = healthcareProvider.address;
                    } else {
                        this.$props.serviceRequest.facility.address = {
                            city: '',
                            fullAddress: '',
                            state: '',
                            zip: '',
                        };
                    }
                    this.copyDropoffAddresses();
                    if (this.$props.serviceRequest.service.type === 'Interpretation' &&
                        this.$props.serviceRequest.interpretation.serviceType !== 'In-Person') {
                        if (healthcareProvider.email) {
                            this.$props.serviceRequest.facility.email = healthcareProvider.email;
                        } else {
                            this.$props.serviceRequest.facility.email = '';
                        }
                    }

                    if (this.$props.serviceRequest.service.type === 'Transportation' &&
                        healthcareProvider.dropOffInstruction) {
                        this.$props.serviceRequest.dropoffAddress.dropOffInstruction =
                            healthcareProvider.dropOffInstruction;
                    }
                    if (this.$props.serviceRequest.service.type === 'Transportation' &&
                        healthcareProvider.pickupInstruction) {
                        this.$props.serviceRequest.pickupAddress.pickupInstruction =
                            healthcareProvider.pickupInstruction;
                    }
                }
            });
        }
    }
    private copyPatientAddress(fullname: string) {
        if (this.patient) {
            this.patient.forEach((patient) => {
                if (patient.fullName === fullname) {
                    if (patient.address) {
                        this.$props.serviceRequest.patient.address = patient.address;
                    } else {
                        this.$props.serviceRequest.patient.address = {
                            city: '',
                            fullAddress: '',
                            state: '',
                            zip: '',
                        };
                    }
                    this.copyPickupAddresses();
                    if (patient.email) {
                        this.$props.serviceRequest.patient.email = patient.email;
                    } else {
                        this.$props.serviceRequest.patient.email = '';
                    }
                    if (patient.phone) {
                        this.$props.serviceRequest.patient.phone = patient.phone;
                    } else {
                        this.$props.serviceRequest.patient.phone = '';
                    }
                }
            });
        }
    }
    private preStep() {
        this.$router.go(-1);
    }
    private next() {
        this.$props.serviceRequest.stops.isStop3Valid = true;
        if (this.locations) {
            this.locations.forEach((location) => {
                if (location.id === this.$props.serviceRequest.billingLocationId) {
                    this.$props.serviceRequest.billingLocation = location;
                    return;
                }
            });
        }
        this.$router.push({ path: MedTransGoConstants.URL_SERVICE_REQUEST_CONFIRMATION });
    }
    private async getHealthcareProviders() {
        const response = await ObjectFactory.getProviderService()
            .getHealthcareProviders(this.$store.state.serverUrl, '', 0, MedTransGoConstants.DB_QUERY_MAX_RESULT);
        this.healthcareProviders = response.data as any;
        this.$data.providersOptions = [];
        this.healthcareProviders.forEach((healthcareProvider) => {
            if (healthcareProvider.status === 'ACTIVE') {
                const providersOption = {
                    value: healthcareProvider.fullname,
                    text: healthcareProvider.fullname,
                };
                this.$data.providersOptions.push(providersOption);
            }
        });
    }
    private async getPatientList() {
        const response = await ObjectFactory.getPatientService()
            .getPatientList(this.$store.state.serverUrl, '', 0, 1000);
        this.$data.patientOptions = response.data as any;
    }
    private addEmail() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (this.healthcareProviders) {
            if (serviceRequest.service.type === 'Interpretation') {
                const objIndex = this.healthcareProviders.findIndex(((obj) =>
                    obj.fullname === this.$props.serviceRequest.facility.name));
                serviceRequest.facility.email = this.healthcareProviders[objIndex].email;
            }
        }
    }
    private addAppointmentDateTime() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments.length < 20) {
            serviceRequest.appointments.push({
                date: '',
                time: '',
                timezone: DateUtils.getLocalTimezone(),
            });
        }
    }
    private removeAppointmentDateTime(index: number) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        if (serviceRequest.appointments.length > 1) {
            serviceRequest.appointments.splice(index, 1);
        }
    }
    private onMultipleAppointment() {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        serviceRequest.multipleAppointment = !serviceRequest.multipleAppointment;
        serviceRequest.appointments = [{
            date: '',
            time: '',
            timezone: DateUtils.getLocalTimezone(),
        }];
    }
    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

    private onPatientSelect(selectedOption: Patient) {
        const serviceRequest = this.$props.serviceRequest as ServiceRequestModel;
        serviceRequest.patient.fullName = selectedOption.fullName;
        serviceRequest.patient.email = selectedOption.email;
        if (selectedOption.address) {
            serviceRequest.patient.address = selectedOption.address;
        } else {
            serviceRequest.patient.address = {
                fullAddress: '',
                city: '',
                locality: '',
                subLocality: '',
                state: '',
                zip: '',
                country: '',
                landmark: '',
                latitude: '' as any,
                longitude: '' as any,
            };
        }
        serviceRequest.patient.phone = selectedOption.phone;
        serviceRequest.patient.birthdate = selectedOption.birthdate;
    }

}
